<template>
  <ul class="nav-btns">
    <li
      class="nav-btns__item"
      v-for="route of routes"
      :key="route.name"
    >
      <router-link
        class="nav-btns__link"
        :to="{ name: route.name}"
      >
        {{ route.text }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    routes: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-btns {
    display: flex;
    gap: 16px;

    &__link {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      padding: 10px 15px;
      min-width: 160px;
      min-height: 40px;
      line-height: normal;
      color: $font_color_alt;
      background-color: $color_controls;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.42);
      transition: box-shadow .3s ease-in-out, background-color .3s ease-in-out;

      &.router-link-active {
        background-color: $color_second-border2;
      }

      &:focus,
      &:hover {
        box-shadow: none;
      }

      &:active {
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.45);
      }
    }
  }
</style>
